import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import IntlMessages from 'util/IntlMessages';

const ArendeStatusOptions =[
    {Value:1,label:<IntlMessages id="Customer.Status1"/>},
    {Value:2,label:<IntlMessages id="Customer.Status2"/>},
    {Value:3,label:<IntlMessages id="Customer.Status3"/>},
    {Value:4,label:<IntlMessages id="Customer.Status4"/>},
]
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
function SelectKunderType(props) {
    const classes = useStyles();
    const [Type, settype] = React.useState(0);
    const handleChange = (event) => {
        settype(event.target.value);
        props.onChangeHandle("Kundstatus",event.target.value)
    };
    return (
        <form className={classes.root}>
            <div style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
            select
            label={<IntlMessages id="Chips.customers.Status" />}
            variant="outlined"
            size="small"
            value={0}
            fullWidth
            onChange={handleChange}
            SelectProps={{
                native: true,
            }}
        >
            <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
            {ArendeStatusOptions.map((option) => (
                <option key={option.Value} value={option.Value}>
                    {option.label}
                </option>
            ))}
        </TextField>
        </div>
        </form>
    );
}

export default SelectKunderType;